import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function Seo({ titleKey, descriptionKey }) {
    const { t, i18n } = useTranslation();

    console.log('Description ' + t(descriptionKey));
    return (
        <Helmet>
            <html lang={i18n.language} />
            <title>Ourobor | {t(titleKey)}</title>
            <meta name="description" content={t(descriptionKey)} />
        </Helmet>
    );
}

export default Seo;